<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav>
        <ul class="footer-menu">
          <li @click="scrollToTop">
            <router-link :to="{path:'/admin/overview'}">Ir para dashboard</router-link>
          </li>
        </ul>
      </nav>
      <div class="copyright text-center">
        Grupo NSC - Versão  {{ release }}
      </div>
    </div>
  </footer>
</template>
<script>
import { version } from "../../package";

  export default {
    data(){
      return{
        release: version
      }
    },
     methods: {
      scrollToTop() {
          window.scrollTo(0,0);
      }
    }
  }

</script>
<style>

</style>
